import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { GeneralAction, IModalAction } from '@models/models';
import { finalize, takeUntil } from 'rxjs/operators';
import { MessageService } from '@services/helpers/message-service/message.service';
import { LeadSourcesDataService } from '@services/lead-sources/lead-sources.data.service';
import { LeadSourceColor, LeadSourceItem } from '@models/lead-sources.model';

@Component({
	selector: 'manage-lead-source',
	template: require('./manage-lead-source-modal.component.html'),
	styles: [require('./manage-lead-source-modal.component.scss')]
})
export class ManageLeadSourceModalComponent implements OnInit, OnDestroy {
	@Input() colours: Array<LeadSourceColor> = [];
	@Input() action: IModalAction<GeneralAction>;
	@Input() selectedItem: LeadSourceItem;
	selectedColour: LeadSourceColor;
	btnDisabled: boolean;
	active: boolean;
	leadName = '';

	private unsubscribe: Subject<void> = new Subject<void>();

	constructor(
		public activeModal: NgbActiveModal,
		private leadSourcesService: LeadSourcesDataService,
		private messageService: MessageService
	) {}

	ngOnInit(): void {
		this.prepareDefaultDataToShow();
	}

	ngOnDestroy(): void {
		this.unsubscribe.next();
		this.unsubscribe.complete();
	}

	onSubmit(): void {
		if (this.isDataValid()) {
			const dataToSave = {
				colour: this.selectedColour.name,
				name: this.leadName
			};

			this.btnDisabled = true;
			this.leadSourcesService
				.sendAction(this.action.props.url, this.action.props.method, dataToSave)
				.pipe(
					takeUntil(this.unsubscribe),
					finalize((): boolean => (this.btnDisabled = false))
				)
				.subscribe(
					(): void => this.activeModal.close(this.action.action),
					(err): void => this.handleError(err)
				);
		}
	}

	onDismiss(): void {
		this.activeModal.dismiss();
	}

	setColor(colour: LeadSourceColor): void {
		this.selectedColour = colour;
		this.active = false;
	}

	openSelect(ev): void {
		this.active = true;
		ev.stopPropagation();
	}

	closeSelect(ev): void {
		ev.stopPropagation();
		this.active = false;
	}

	private isDataValid(): boolean {
		if (!this.leadName || !this.leadName.trim()) {
			this.messageService.showToaster('e_0', 'leadSources');
			return false;
		}

		if (
			this.leadName.trim().split(' ').length === 1 &&
			this.leadName.trim().toLowerCase() === 'none'
		) {
			this.messageService.showToaster('e_2', 'leadSources');
			return false;
		}

		if (!this.selectedColour) {
			this.messageService.showToaster('e_1', 'leadSources');

			return false;
		}

		return true;
	}

	private prepareDefaultDataToShow(): void {
		if (this.action.action === 'EDIT_EXISTING') {
			this.leadName = this.selectedItem.name;
			this.selectedColour = this.selectedItem.colour;
		}
	}

	private handleError({ error }): void {
		const { errorMessage, errorTitle } = error;
		this.messageService.showErrorFromBackend(errorTitle, errorMessage);
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=oom9nsliule!./web/modern/components/settings/lead-sources-section/modals/manage-lead-source-modal/manage-lead-source-modal.component.ts